export default __webpack_public_path__ + "50a29e9.png";